import { AfterViewInit, Directive, Inject, Input } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

import { CommonWindow } from '@core/domain/models/common-window.model';
import { AkamaiService } from '@shared/services/akamai.service';

@Directive({
    selector: '[cmsAkamaiWidthImage]',
})
export class CmsAkamaiWidthImageDirective implements AfterViewInit {
    @Input('cmsAkamaiWidthImage') public imageUrl: string;

    @Input() public cmsNativeElement: any;

    @Input('cmsAkamaiWidthImageAttribute') public attribute: string = 'src';

    constructor(
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {}

    public async ngAfterViewInit() {
        if (await this.cmsNativeElement) {
            const element: HTMLVideoElement = await this.cmsNativeElement;
            const { offsetWidth } = element.parentElement.parentElement;
            const url = new URL(this.imageUrl);
            const impolicy = url.searchParams.get('impolicy');
            const imageUrl = AkamaiService.useAkamaiImage(this.window, this.imageUrl, offsetWidth ?? 0, impolicy);
            element.setAttribute(this.attribute, imageUrl.toString());
        }
    }
}
